export class UserSiteActivationEntity {
    userSiteId;
    isActive;
  
    constructor(userSiteId, isActive) {
      this.userSiteId = userSiteId;
      this.isActive = isActive;
    }
  }
  